exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".brandHolder {\r\n  display: block;\r\n  padding: 10px;\r\n  background: #3c3d3b;\r\n  /*background: inherit;*/\r\n  position: absolute;\r\n  z-index: 20;\r\n  left: 30px;\r\n  border-radius: 10px;\r\n\r\n}\r\n.brand {\r\n}\r\n\r\na:focus, a:hover {\r\n  color: #abc1a7;\r\n}\r\n\r\na {\r\n  color: #7e9b7c;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/main/menu/menu.component.css
// module id = 307
// module chunks = 1